import { render, staticRenderFns } from "./t-orm-buttons.vue?vue&type=template&id=17d75299&scoped=true&lang=pug&"
import script from "./t-orm-buttons.vue?vue&type=script&lang=js&"
export * from "./t-orm-buttons.vue?vue&type=script&lang=js&"
import style0 from "./t-orm-buttons.vue?vue&type=style&index=0&id=17d75299&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d75299",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VList,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VMenu,VRow,VTooltip})
